module.exports = __webpack_public_path__ + "static/media/polda.3d27282e.png";